export function snapshot2List(snapshot) {
    let value = snapshot.val()
    let data = []
    for (let vid in value) {
        data.push({
            id: vid,
            ...value[vid],
        })
    }
    return data
}